// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './filters'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './style.css'
import MetaInfo from 'vue-meta-info';

import axios from './common/axios'

Vue.prototype.$axios=axios;


Vue.config.productionTip = false

Vue.use(ElementUI,{
  size:'small'
});
Vue.use(MetaInfo);

const doResize = (el,binding,vnode) => {
  const { componentInstance: $table } = vnode
    
  const { value } = binding

  if (!$table.height) {
    throw new Error(`el-$table must set the height. Such as height='100px'`)
  }
  const bottomOffset = (value && value.bottomOffset) || 50

  if (!$table) return

  const height = window.innerHeight - el.getBoundingClientRect().top - bottomOffset
  $table.layout.setHeight(height)
  $table.doLayout()
}

Vue.directive("el-height-adaptive-table", {
  bind(el, binding, vnode) {
    
   el.resizeListener = () => {
     doResize(el,binding,vnode)
   }

   //addResizeListener(el, el.resizeListener)
   window.addEventListener('resize', el.resizeListener)
 },
 update(el,binding,vnode){
   doResize(el,binding,vnode)
 },
 unbind(el) {
   //removeResizeListener(el, el.resizeListener)
   window.removeEventListener('resize',el.resizeListener)
 }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js